<template>
  <v-container fill-height justify-center align-center>
    <v-card width="400" class="pa-6">
      <v-card-title class="text-center">
        <v-icon left>mdi-lock</v-icon>
        Change Password
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent="changePassword">
          <v-text-field
            v-model="currentPassword"
            :type="showPasswords ? 'text' : 'password'"
            label="Current Password"
            variant="outlined"
            class="mb-4"
            required
          ></v-text-field>

          <v-text-field
            v-model="newPassword"
            :type="showPasswords ? 'text' : 'password'"
            label="New Password"
            variant="outlined"
            class="mb-4"
            required
          ></v-text-field>

          <v-text-field
            v-model="confirmPassword"
            :type="showPasswords ? 'text' : 'password'"
            label="Confirm New Password"
            variant="outlined"
            class="mb-6"
            required
          ></v-text-field>

          <v-checkbox
            v-model="showPasswords"
            label="Show passwords"
            density="compact"
            class="mb-4"
          ></v-checkbox>

          <v-btn type="submit" color="primary" block> Change Password </v-btn>

          <v-btn to="/dashboard" variant="text" block class="mt-2"> Cancel </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAppStore } from "@/store/app";

const router = useRouter();
const appStore = useAppStore();

const currentPassword = ref("");
const newPassword = ref("");
const confirmPassword = ref("");
const showPasswords = ref(false);

const changePassword = async () => {
  if (!currentPassword.value || !newPassword.value || !confirmPassword.value) {
    appStore.sendErrorNotice("All fields are required");
    return;
  }

  if (newPassword.value !== confirmPassword.value) {
    appStore.sendErrorNotice("Passwords do not match");
    return;
  }

  if (newPassword.value.length < 8) {
    appStore.sendErrorNotice("Password must be at least 8 characters");
    return;
  }

  // TODO: Call password change API
  console.log("Changing password...");

  appStore.sendSuccessNotice("Password changed successfully");
  router.push("/dashboard");
};
</script>
